
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-edit-region-title.html
riot.tag2('menu-item-edit-region-title',
  '<i class="material-icons floating-menu_icon">edit</i> <span class="floating-menu_label">Rename</span>',
  '',
  'class="floating-menu_item" onclick="{editTitle}"', function(opts) {
'use strict';

var _this = this;

var _menuUi = require('lib/menu-ui');

var _util = require('lib/util');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_menuUi.mui.registerMenuItem(this, 'editRegionTitle');

this.editTitle = function (e) {
  e.stopPropagation();
  _this.parent.regionTag.refs.title.focus();
  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(_this.parent),
    action: 'Rename Region',
    label: 'Selection'
  });
  _this.parent.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-edit-region-title')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-edit-region-title.html
// module id = 707
// module chunks = 0